// Types for Quality Inspection System

export interface QualityInspection {
  id: string;
  work_order_id: string;
  process_record_id?: string;
  plybook_execution_id?: string;
  inspection_type: InspectionType;
  inspection_point?: string;
  ply_number?: number;
  status: InspectionStatus;
  result?: InspectionResult;
  inspector_id?: string;
  inspection_date?: string;
  notes?: string;
  has_defects: boolean;
  defect_count: number;
  requires_rework: boolean;
  rework_description?: string;
  corrective_action?: string;
  created_at: string;
  updated_at: string;
  // Relations
  inspector?: { full_name: string };
  defects?: QualityDefect[];
}

export interface QualityDefect {
  id: string;
  inspection_id: string;
  defect_type: string;
  severity: DefectSeverity;
  location?: string;
  description?: string;
  photo_url?: string;
  is_resolved: boolean;
  resolution_notes?: string;
  resolved_by?: string;
  resolved_at?: string;
  created_at: string;
}

export interface DefectType {
  id: string;
  name: string;
  category?: string;
  severity_default: DefectSeverity;
  description?: string;
  is_active: boolean;
  sort_order: number;
}

export type InspectionType = 'general' | 'dimensional' | 'visual' | 'structural' | 'process';
export type InspectionStatus = 'pending' | 'in_progress' | 'completed';
export type InspectionResult = 'approved' | 'rejected' | 'conditional' | 'on_hold';
export type DefectSeverity = 'critical' | 'major' | 'minor' | 'cosmetic';

export const INSPECTION_TYPE_LABELS: Record<InspectionType, string> = {
  general: 'General',
  dimensional: 'Dimensional',
  visual: 'Visual',
  structural: 'Estructural',
  process: 'De Proceso',
};

export const INSPECTION_STATUS_LABELS: Record<InspectionStatus, string> = {
  pending: 'Pendiente',
  in_progress: 'En Progreso',
  completed: 'Completada',
};

export const INSPECTION_STATUS_COLORS: Record<InspectionStatus, string> = {
  pending: 'bg-yellow-500/10 text-yellow-500',
  in_progress: 'bg-blue-500/10 text-blue-500',
  completed: 'bg-green-500/10 text-green-500',
};

export const INSPECTION_RESULT_LABELS: Record<InspectionResult, string> = {
  approved: 'Aprobado',
  rejected: 'Rechazado',
  conditional: 'Condicional',
  on_hold: 'En Espera',
};

export const INSPECTION_RESULT_COLORS: Record<InspectionResult, string> = {
  approved: 'bg-green-500 text-white',
  rejected: 'bg-red-500 text-white',
  conditional: 'bg-amber-500 text-white',
  on_hold: 'bg-gray-500 text-white',
};

export const DEFECT_SEVERITY_LABELS: Record<DefectSeverity, string> = {
  critical: 'Crítico',
  major: 'Mayor',
  minor: 'Menor',
  cosmetic: 'Cosmético',
};

export const DEFECT_SEVERITY_COLORS: Record<DefectSeverity, string> = {
  critical: 'bg-red-600 text-white',
  major: 'bg-orange-500 text-white',
  minor: 'bg-yellow-500 text-black',
  cosmetic: 'bg-blue-400 text-white',
};

export const INSPECTION_POINTS = [
  { value: 'lamination', label: 'Laminado', icon: 'Layers' },
  { value: 'vacuum', label: 'Vacío', icon: 'Wind' },
  { value: 'curing', label: 'Curado', icon: 'Flame' },
  { value: 'demolding', label: 'Desmoldeo', icon: 'Package' },
  { value: 'finishing', label: 'Acabado', icon: 'Sparkles' },
  { value: 'final', label: 'Final', icon: 'CheckCircle' },
] as const;
